<div class="form-group">
  <div class="row">
    <div class="col-xl-12">
      <div class="row">
        <div id="orange-column-style" class="col-xl-3 bg-orange"></div>
        <div class="col-xl-9 p-2 px-3">
          <div class="d-flex flex-row">
            <img src="../../../assets/images/icons/icon-paper-airplane.svg" width="55" height="auto" />
            <span class="mt-4 ml-1" style="font-size: 20px">Solicitar Open Finance</span>
          </div>
          <div style="background-color: #303030" class="p-2 rounded mt-3">
            <p class="mb-0">
              Com o consentimento do seu cliente, tenha acesso ao histórico financeiro, e aproveite a oportunidade e
              oferte os produtos e servições exclusivos.
            </p>
          </div>
          <div style="background-color: #303030" class="px-2 py-1 rounded mt-3">
            <p class="text-center mb-0">Sua solicitação será encaminhada para o email</p>
          </div>
          <div style="background-color: #303030" class="px-2 py-1 rounded mt-3">
            <p class="text-center mb-0">{{email}}</p>
          </div>
          <button
            class="btn btn-success btn-rounder float-right mt-4"
            type="button"
            (click)="createRequest()"
            mat-dialog-close
          >
            <span><strong>Solicitar</strong></span>
          </button>
        </div>
      </div>

      <button mat-mini-fab class="btn-gray float-right ml-1" mat-dialog-close>
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>
</div>
